export default __webpack_public_path__ + "static/media/page-title-cases.87298f88.svg";